mutation UpdateHifoCascade(
  $id: ID!
  $hifoCascadeInput: HifoCascadeChangeInput!
) {
  updateHifoCascade(input: { id: $id, hifoCascadeInput: $hifoCascadeInput }) {
    hifoCascade {
      id
      status
      deadline
      currentTrancheNumber
      notes
      statusChangeNotes
      roomForFunding {
        currency
        minorUnit
      }
      minimumGrantAmount {
        currency
        minorUnit
      }
    }
  }
}
